<template>
  <v-card>
    <v-card-title>گزارش {{ layout.title }}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field label="از کد کالا" type="number" v-model="filters.ware__code__gte" clearable />
          <v-text-field label="تا کد کالا" type="number" v-model="filters.ware__code__lte" clearable class="mt-3" />
        </v-col>
        <v-col cols="12" md="2">
          <date label="از تاریخ" v-model="filters.factor__date__gte" :defualt="false" clearable />
          <div class="mt-3">
            <date label="تا تاریخ" v-model="filters.factor__date__lte" :defualt="false" clearable />
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field label="از شماره فاکتور" type="number" v-model="filters.factor__code__gte" clearable />
          <v-text-field label="تا شماره فاکتور" type="number" v-model="filters.factor__code__lte" clearable class="mt-3" />
        </v-col>
        <v-col cols="12">
          <m-datatable :headers="headers" :api-url="url" :filters.sync="filters" :show-select="false" ref="datatable" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";
export default {
  props: {
    wareId: {},
    type: {
      required: true,
    },
  },
  mixins: [wareApiMixin],
  data() {
    return {
      url: "reports/buySale",
      ware: null,
      filters: {
        factor__type__in: "",
        ware: "",
      },
      layout: {
        title: "",
      },
      headers: [
        {
          text: "کد",
          value: "ware.code",
          sortable: false,
        },
        {
          text: "نام",
          value: "ware.name",
          sortable: false,
        },
        {
          text: "نوع فاکتور",
          value: "factor.type",
          items: [
            {
              text: "موجودی اول دوره",
              value: "fpi",
            },
            {
              text: "فروش",
              value: "sale",
            },
            {
              text: "برگشت از فروش",
              value: "backFromSale",
            },
            {
              text: "خرید",
              value: "buy",
            },
            {
              text: "برگشت از خرید",
              value: "backFromBuy",
            },
          ],
        },
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
        },
        {
          text: "شماره عطف",
          value: "factor.id",
        },
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "خریدار/فروشنده",
          value: "factor.account.name",
          type: "text",
        },
        {
          text: "انبار",
          value: "warehouse.name",
          type: "text",
        },
        {
          text: "تعداد",
          value: "count",
          type: "numeric",
          sortable: false,
        },
        {
          text: "فی",
          value: "fee",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ",
          value: "value",
          type: "numeric",
          sortable: false,
        },
        {
          text: "تخفیف",
          value: "discountValue",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مالیات",
          value: "tax_value",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ کل",
          value: "total_value",
          type: "numeric",
          sortable: false,
        },
        {
          text: "شرح فاکتور",
          value: "factor.explanation",
          type: "text",
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      Promise.all([this.getWares()]).then((data) => {
        this.init();
      });
    },
    init() {
      this.log("init list");
      this.setLayout();
      this.setDefaultFilters();

      if (this.wareId) {
        this.ware = this.wares.filter((o) => o.id == this.wareId)[0];
      }
    },
    setLayout() {
      if (this.type == "sale") this.layout.title = "فروش";
      else this.layout.title = "خرید";
    },
    setDefaultFilters() {
      if (this.type == "sale") {
        this.filters["factor__type__in"] = ["sale", "backFromSale"].join(",");
      } else {
        this.filters["factor__type__in"] = ["buy", "backFromBuy"].join(",");
      }
    },
    selectWare() {
      this.filters.ware = this.ware.id;
    },
  },
  watch: {
    form() {
      this.init();
    },
    type() {
      this.init();
    },
    ware: {
      handler() {
        this.selectWare();
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss"></style>
